import { combineReducers } from 'redux';

import {
    SponsorBannerDetailReducerState,
    sponsorBannerDetailReducer,
} from '../sponsor-banner-detail/store/sponsor-banner-detail-reducer';
import {
    SponsorBannerListReducerState,
    sponsorBannerListReducer,
} from '../sponsor-banner-list/store/sponsor-banner-list-reducer';

export interface SponsorBannerReducerState {
    sponsorBannerList: SponsorBannerListReducerState;
    sponsorBannerDetail: SponsorBannerDetailReducerState;
}

export const sponsorBannerReducer = combineReducers<SponsorBannerReducerState>({
    sponsorBannerList: sponsorBannerListReducer,
    sponsorBannerDetail: sponsorBannerDetailReducer,
});
